const appData = {
  apiKey: "AIzaSyBjnsedFLB4nVkgtsi5nl3fMcCHxLcDMVI",
  libraries: ["places"],
};
export default appData;
